import { getRequest, replaceInUrl, postRequest, putRequest } from './index';
import apiEndpoints from './apiEndpoints';

export const createMetalStreamBankAccountRequest = ({
  ApplicationUid,
  MetalStreamBankAccountRequest,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.metalStream.postBankAccount, {
      ApplicationUid,
    }),
    MetalStreamBankAccountRequest,
  );

export const createMetalStreamAmountRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.metalStream.postAmount, {
      ApplicationUid,
    }),
    data,
  );

export const updateMetalStreamAmountRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.metalStream.putAmount, {
      ApplicationUid,
    }),
    data,
  );

export const createMetalStreamAllocationsRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.metalStream.postAllocations, {
      ApplicationUid,
    }),
    data,
  );

export const updateMetalStreamAllocationsRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.metalStream.putAllocations, {
      ApplicationUid,
    }),
    data,
  );

export const getMetalStreamProductsRequest = ({ ApplicationUid, metalType }) =>
  getRequest(
    replaceInUrl(apiEndpoints.metalStream.getProducts, {
      ApplicationUid,
    }),
    { metalType },
  );

export const createMetalStreamProductsRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.metalStream.postProducts, {
      ApplicationUid,
    }),
    data,
  );

export const updateMetalStreamProductsRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.metalStream.putProducts, {
      ApplicationUid,
    }),
    data,
  );

export const createMetalStreamBankApplicationFundingRequest = ({
  ApplicationUid,
  data,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.metalStream.bankApplicationFunding, {
      ApplicationUid,
    }),
    data,
  );

export const updateMetalStreamBankApplicationFundingRequest = ({
  ApplicationUid,
  data,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.metalStream.bankApplicationFunding, {
      ApplicationUid,
    }),
    data,
  );
